import { render, staticRenderFns } from "./chinaEuropeOceanShipping.vue?vue&type=template&id=12614edd&"
import script from "./chinaEuropeOceanShipping.vue?vue&type=script&lang=js&"
export * from "./chinaEuropeOceanShipping.vue?vue&type=script&lang=js&"
import style0 from "./chinaEuropeOceanShipping.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports